export default __webpack_public_path__ + "static/media/facebookRound.915ef78c.svg";